import cookie from 'react-cookie';

export const OPEN_WHATS_NEW_MODAL = 'OPEN_WHATS_NEW_MODAL';
export const CLOSE_WHATS_NEW_MODAL = 'CLOSE_WHATS_NEW_MODAL';

export const finishBwWhatsNew = () => () => {
  cookie.save('bw_whats_new_modal', true, {
    path: '/',
    domain: location.hostname,
    maxAge: 31536000, // 1 year
    expires: new Date((new Date()).getTime() + (31536000 * 1000)),
  });
};

export const openWhatsNewModal = () => (dispatch) => {
  dispatch({ type: OPEN_WHATS_NEW_MODAL });
  dispatch(finishBwWhatsNew());
};

export const closeWhatsNewModal = () => ({ type: CLOSE_WHATS_NEW_MODAL });



// WEBPACK FOOTER //
// ./src/actions/whatsNewModal.js